import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CartCtx = createContext(null);
const KEY = 'lawatan_cart_v1';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (error) {
      console.error('Failed to load cart from storage:', error);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (error) {
      console.error('Failed to persist cart to storage:', error);
    }
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((p) => p.id === product.id);
      if (found) return prev.map((p) => p.id === product.id ? { ...p, qty: p.qty + qty } : p);
      return [...prev, { id: product.id, name: product.name_fr || product.name_en, image: product.image, price_eur: product.price_eur, weight_label: product.weight_label, qty }];
    });
    setOpen(true);
  };

  const setQty = (id, qty) => {
    setItems((prev) => prev.map((p) => p.id === id ? { ...p, qty: Math.max(1, qty) } : p));
  };

  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const clear = () => setItems([]);

  const total = items.reduce((s, p) => s + (p.price_eur || 0) * p.qty, 0);
  const count = items.reduce((s, p) => s + p.qty, 0);

  const value = useMemo(
    () => ({ items, add, setQty, remove, clear, total, count, open, setOpen }),
    [items, total, count, open]
  );

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
